// Client\client-vite\src\components\Navbars\SalesPersonNavbar.tsx
import { LogOut, Settings, User, Users2 } from "lucide-react"
import { Link } from "react-router-dom"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { ThemeModeToggle } from "../Toggles/ThemeModeToggle"
import { SidebarTrigger } from "../ui/sidebar"

export const SalesPersonNavbar = () => {
    return (
        <nav className="p-4 flex items-center justify-between border-b bg-background">
            
            {/* LEFT */}
            <div>
                {/* CollapseButtons */}
                <SidebarTrigger />
            </div>

            {/* CENTER */}
            <div className="flex-1 flex justify-center">
                <Link to="/" className="font-medium hover:underline">
                    Dashboard
                </Link>
            </div>

            {/* RIGHT */}
            <div className="flex items-center gap-4 ml-auto">
                <ThemeModeToggle />

                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Avatar className="cursor-pointer">
                            <AvatarImage src="https://github.com/shadcn.png" />
                            <AvatarFallback>CN</AvatarFallback>
                        </Avatar>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" sideOffset={10}>
                        <DropdownMenuLabel>My Account</DropdownMenuLabel>
                        <DropdownMenuSeparator />
                        <DropdownMenuItem>
                            <User className="h-4 w-4 mr-2" />
                            Profile
                        </DropdownMenuItem>
                        <DropdownMenuItem>
                            <Settings className="h-4 w-4 mr-2" />
                            Settings
                        </DropdownMenuItem>
                        <DropdownMenuItem>
                            <Users2 className="h-4 w-4 mr-2" />
                            Team
                        </DropdownMenuItem>
                        <DropdownMenuItem className="text-destructive">
                            <LogOut className="h-4 w-4 mr-2" />
                            Logout
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
        </nav>
    )
}

export default SalesPersonNavbar
